import { FetchHelper } from 'kryfe-lib';
// import store from '../../store';

const { Consts, FetchRequest, FetchResponse } = FetchHelper;

// FetchRequest.connectToRedux(store);

// if the schema of response is not like
// { header: { code: xxx, message: xxx }, body: { ... } }
// you need to reset the response like below
FetchResponse.parseHeader = res => {
  return {
    code: res.status,
    message: res.message,
    msgId: res.msgId,
  };
};

FetchResponse.parseBody = res => {
  return res.content;
};

FetchResponse.isSuccess = code => {
  return code === 1000;
};

export { Consts, FetchRequest };



// WEBPACK FOOTER //
// ./src/shared/utils/fetchHelper.js